export default Header;
import { Bars3Icon } from '@heroicons/react/20/solid';
import { twMerge } from 'tailwind-merge';
import { Config } from 'vike-react/Config';

import { wrapPageTitle } from '@/renderer/getPageTitle';

function Header({
  title,
  pageTitle,
  Icon: _Icon,
  className,
  children,
  as = 'h2',
}: {
  title: string | JSX.Element | JSX.Element[];
  pageTitle?: string;
  Icon?: React.ForwardRefExoticComponent<React.PropsWithoutRef<React.SVGProps<SVGSVGElement>>>;
  className?: string;
  children?: JSX.Element | JSX.Element[];
  as?: React.ElementType;
}) {
  const As = as;

  return (
    <header
      className={twMerge(
        'shrink-0 border-zinc-900/10 border-b bg-[Canvas] p-4 py-0 shadow-xs md:px-6 dark:border-white/10',
        className,
      )}
    >
      <Config title={wrapPageTitle(pageTitle || title)} />
      <div className="flex flex-row items-center justify-between space-x-2">
        {/* <ChevronLeftIcon className="h-6 w-6 shrink-0 text-zinc-800 dark:text-zinc-300 sm:hidden" /> */}
        <label
          htmlFor="nav-checkbox"
          className="flex select-none items-center justify-center rounded-sm p-1 hover:bg-zinc-900/5 md:hidden dark:hover:bg-white/5"
        >
          <Bars3Icon
            height={20}
            className="m-auto size-5 shrink-0 text-zinc-800 md:hidden dark:text-zinc-300"
          />
        </label>
        <div className="flex w-full flex-row items-center px-2 md:space-x-4 md:px-0">
          {/* {Icon && <Icon className="hidden h-6 w-auto shrink-0 text-zinc-500 sm:hidden" />} */}
          <div className="flex flex-1 flex-row items-center justify-between">
            <As className="m-0 select-none font-semibold text-base text-zinc-800 leading-7 dark:text-zinc-300">
              {title}
            </As>
            {children}
          </div>
        </div>
      </div>
    </header>
  );
}
